import React, { useState, useCallback } from "react";
import { ReferenceInput, AutocompleteInput } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";

import LocationQuickCreateButton from "./LocationQuickCreateButton";

const useStyles = makeStyles({
  root: {
    display: "flex"
  }
});

const LocationReferenceInput = (props) => {
  const classes = useStyles();
  const [version, setVersion] = useState(0);
  const handleChange = useCallback(() => setVersion(version + 1), [version]);

  return (
    <div className={classes.root}>
      <div>
        <ReferenceInput
          key={version}
          label="Location"
          filterToQuery={(searchText) => ({ name: searchText })}
          format={(v) => (v && v.id ? v.id : v)}
          {...props}
        >
          <AutocompleteInput
            optionText="name"
            optionValue="id"
            helperText="Overrides default location (default is home school)"
          />
        </ReferenceInput>
      </div>

      <LocationQuickCreateButton onChange={handleChange} />
    </div>
  );
};

export default LocationReferenceInput;
